import { Dispatch } from 'react';
import { SuSyApi } from '../../api/susyApi';
import { MergeOrganizationParameters } from '../../components/admin/organization/advancedEditing/MergeOrganizationsForm';
import { FacultyAction, FacultyActionType } from '../actions/FacultyActions';
import { Faculty } from '../types';

export const getAllAdminFaculties =
    () => async (dispatch: Dispatch<FacultyAction>) => {
        const response = await SuSyApi.get(`/faculty/admin`);
        dispatch({
            type: FacultyActionType.GET_ALL_ADMIN_FACULTIES,
            payload: response.data,
        });
    };
export const getAllFaculties =
    () => async (dispatch: Dispatch<FacultyAction>) => {
        const response = await SuSyApi.get(`/faculty`);
        dispatch({
            type: FacultyActionType.GET_ALL_FACULTIES,
            payload: response.data,
        });
    };
export const getFaculty =
    (faculty: Faculty) => async (dispatch: Dispatch<FacultyAction>) => {
        const response = await SuSyApi.get(`/faculty/${faculty._id}`);
        dispatch({
            type: FacultyActionType.GET_FACULTY,
            payload: response.data,
        });
    };

export const createFaculty =
    (faculty: Faculty) => async (dispatch: Dispatch<FacultyAction>) => {
        const response = await SuSyApi.post(`/faculty`, faculty);
        dispatch({
            type: FacultyActionType.CREATE_FACULTY,
            payload: response.data,
        });
    };

export const updateFaculty =
    (faculty: Faculty) => async (dispatch: Dispatch<FacultyAction>) => {
        const response = await SuSyApi.put(`/faculty/${faculty._id}`, faculty);
        dispatch({
            type: FacultyActionType.UPDATE_FACULTY,
            payload: response.data,
        });
    };

export const deleteFaculties =
    (ids: Array<string>, transferToId: string) =>
    async (dispatch: Dispatch<FacultyAction>) => {
        const response = await SuSyApi.delete(`/faculty`, {
            data: {
                ids,
                transferToId,
            },
        });
        dispatch({
            type: FacultyActionType.DELETE_FACULTIES,
            payload: response.data,
        });
    };
export const mergeFaculties =
    (parameters: MergeOrganizationParameters) =>
    async (dispatch: Dispatch<FacultyAction>) => {
        const response = await SuSyApi.post(`/faculty/merge`, parameters);
        dispatch({
            type: FacultyActionType.MERGE_FACULTIES,
            payload: response.data,
        });
    };
